import React from 'react';
import './About.css';

const highlights = [
  { icon: 'fa-user-tie',           title: 'Expert Guidance',       desc: 'Experienced consultants at every step of your application' },
  { icon: 'fa-file-circle-check',  title: 'Easy Documentation',    desc: 'Clear checklists and step-by-step document support' },
  { icon: 'fa-hand-holding-dollar',title: 'Transparent Pricing',   desc: 'No hidden fees — you know exactly what you pay for' },
  { icon: 'fa-earth-americas',     title: 'Worldwide Coverage',    desc: 'Visa assistance for 50+ countries across all continents' },
];

export default function About() {
  return (
    <section id="about" className="sec sec-dark">
      <div className="container">

        <div className="about-grid">
          {/* Left — copy */}
          <div>
            <p className="label"><i className="fas fa-circle-info"></i> About RoamLife</p>
            <h2 className="sec-title">Digital-First Visa<br />Documentation for <span>Indian Travelers</span></h2>
            <div className="rule"></div>

            <div className="about-body">
              <p>
                <strong>RoamLife</strong> is a digital-first travel documentation company helping
                Indian travelers with tourist visas and travel documentation for destinations worldwide.
              </p>
              <p>
                Our goal is to simplify the visa application process through <strong>expert guidance,
                transparent pricing</strong>, and an easy online experience — from document preparation
                to application support.
              </p>
              <p>
                Whether you're applying for a tourist visa, business visa, or any travel
                documentation, our team assists you at every stage. We believe international
                travel should begin with confidence, not confusion.
              </p>
            </div>

            <div className="about-quote">
              "We believe international travel should begin with confidence, not confusion."
            </div>
          </div>

          {/* Right — image */}
          <div className="about-img-wrap">
            <img
              src="/ChatGPT Image Aug 8, 2026 at 12_44_20 PM-Picsart-BackgroundRemover.png"
              alt="RoamLife travel documentation"
              className="about-img"
            />
          </div>
        </div>

        {/* Highlights row */}
        <div className="about-highlights">
          {highlights.map((h, i) => (
            <div className="ahl" key={i}>
              <div className="ahl-icon">
                <i className={`fas ${h.icon}`}></i>
              </div>
              <h4>{h.title}</h4>
              <p>{h.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
